import WelcomeBanner      from '@/components/dashboard/WelcomeBanner'
import RecentResults      from '@/components/dashboard/RecentResults'
import LinkedTeachers     from '@/components/dashboard/LinkedTeachers'
import WeeklyActivity     from '@/components/dashboard/WeeklyActivity'
import { UpcomingEvents } from '@/components/dashboard/Teachers'

export default function HomePage() {
  return (
    <div className="flex flex-col gap-4">
      <WelcomeBanner />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <RecentResults />
        <LinkedTeachers />
      </div>
      <WeeklyActivity />
      <UpcomingEvents />
    </div>
  )
}
